const envConfig = process.env;
import Func from '../utils/func'
export default {
  connect(callback) {
    const userId = Func.getUserInfo().id || "";
    const deviceId = localStorage.getItem("signalr_device_id") || Func.uuid(16);
    localStorage.setItem("signalr_device_id", deviceId);
    const url = Func.urlCode(envConfig.wsApi + "/api2/chatHub", { deviceId, userId });
    this.hub = new signalR.HubConnectionBuilder().withUrl(url, {
      withCredentials: true,
      transport: signalR.HttpTransportType.WebSockets,
      headers: {
        "x-user-id": userId,
        "x-device-id": deviceId
      },
    }).build();
    this.hub.start();
    if (typeof callback == "function") {
      callback();
    }
    this.hub.on("CustomPing", res => {
      console.log(res)
    });
  },
  invoke(method, group, data) {
    const userInfo = Func.getUserInfo();
    if (!Func.getToken() || !userInfo.id) {
      return;
    }
    if (typeof data == "object") {
      data.userId = userInfo.id;
      const deviceId = localStorage.getItem("signalr_device_id");
      if (deviceId) {
        data.deviceId = deviceId;
      }
      data = JSON.stringify(data)
    }
    if (!this.hub) {
      this.connect(() => {
        this.invoke(method, data);
      })
      return;
    }
    let interval = setInterval(() => {
      if (this.hub.q == "Connected") {
        this.hub.invoke(method, group, data || "");
        clearInterval(interval);
      } else if (this.hub.q == "Disconnected") {
        this.connect(() => {
          this.hub.invoke(method, group, data || "");
        })
        clearInterval(interval);
      }
    }, 100);
  },
  on(method, callback) {
    if (!this.hub) {
      return;
    }
    this.hub.on(method, res => {
      let data = {};
      if (typeof (res) == "object") {
        data = res;
      } else if (typeof (res) == "string") {
        try {
          data = JSON.parse(res);
        } catch (error) {
          console.log(error)
        }
      }
      callback(data);
    });
    return this.hub;
  }
}
// Disconnected：连接已断开
// Connecting：正在尝试连接
// Connected：连接成功
// Reconnecting：正在重新连接（触发 onreconnecting 回调）



// WEBPACK FOOTER //
// ./src/server/websocket.js